

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const FinancialServices = () => {
  const navigate = useNavigate();
  const [animate, setAnimate] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    // Trigger animation when component mounts
    setAnimate(true);
    
    // Handle resize events for responsiveness
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: isMobile ? "20px" : "50px",
      backgroundColor: "#000",
      color: "white",
      minHeight: "90vh",
      boxSizing: "border-box",
    },
    left: {
      flex: isMobile ? "0 1 auto" : "1 1 400px",
      padding: isMobile ? "10px" : "20px",
      textAlign: isMobile ? "center" : "left",
      marginBottom: isMobile ? "20px" : "0",
    },
    heading: {
      fontSize: isMobile ? "28px" : "36px",
      fontWeight: "bold",
      marginBottom: "20px",
      letterSpacing: "0px",
      color: "white",
      lineHeight: "1.2",
    },
    text: {
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: "1.6",
      marginBottom: "30px",
      textAlign: isMobile ? "left" : "justify",
    },
    buttonContainer: {
      display: "flex",
      gap: "15px",
      flexWrap: "wrap",
      justifyContent: isMobile ? "center" : "flex-start",
    },
    button: {
      padding: "12px 25px",
      borderRadius: "25px",
      border: "none",
      fontSize: isMobile ? "14px" : "16px",
      fontWeight: "bold",
      cursor: "pointer",
      transition: "0.3s ease",
      minWidth: isMobile ? "140px" : "auto",
    },
    contactBtn: {
      backgroundColor: "#0078b7",
      color: "white",
    },
    right: {
      flex: isMobile ? "0 1 auto" : "1 1 400px",
      textAlign: "center",
      overflow: "hidden",
      width: isMobile ? "100%" : "auto",
    },
    image: {
      maxWidth: "100%",
      height: "auto",
      maxHeight: isMobile ? "300px" : "none",
      transform: animate ? "translateY(0)" : "translateY(-100px)",
      opacity: animate ? 1 : 0,
      transition: "all 1s ease-in-out",
    },
  };

  return (
    <div style={styles.container}>
      {/* Left Section */}
      <div style={styles.left}>
        <h1 style={styles.heading}>Financial Services</h1>
        <p style={styles.text}>
          Global shifts in behaviours, expectations and Market are affecting how
          people finance, spend, invest and save—causing many financial Services
          firms to rethink their strategies. By connecting insight, experience
          and ecosystems, we can foster stable and inclusive growth through
          innovation and transformation. Together, we can create a more
          efficient financial Services Industry and a better future.
        </p>
        <div style={styles.buttonContainer}>
          <button
            style={{ ...styles.button, ...styles.contactBtn }}
            onClick={() => navigate("/contactus")} // Redirect
          >
            Contact us
          </button>
        </div>
      </div>

      {/* Right Section */}
      <div style={styles.right}>
        <img
          src="/image/visual-website-1.png"
          alt="Financial Services"
          style={styles.image}
        />
      </div>
    </div>
  );
};

export default FinancialServices;